import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import useStore from '@/store/useStore';
import { trackEventWithObject } from '@/utils/gaDataPush';
import beTwMerge from '@/utils/beTwMerge';
import FontIcon from '../FontIcon';

const HeartDropdown = dynamic(() => import('./HeartDropdown'), { ssr: false });

export default function Heart() {
  const [open, setOpen] = useState(false);
  const wishlist = useStore(state => state.wishlist);

  function onHover() {
    if (!open) {
      setOpen(true);
    }
  }

  return (
    <div
      className={beTwMerge('king-wish-list wish-list-icon', open && !!wishlist?.items?.length && 'open')}
      onMouseEnter={() => onHover()}
      onMouseLeave={() => setOpen(false)}
    >
      <a
        href="/shop/wishlist/"
        className="navitem"
        onClick={() => {
          trackEventWithObject({
            event: 'header',
            general_event_category: 'Wish List',
            general_event_section: 'Main Icon',
            general_event_details: 'Undefined',
          });
        }}
        aria-label="Wish List"
      >
        <FontIcon name="heart" />
        <span className="count" data-container="wishlist-count">
          {!!wishlist?.items?.length && wishlist?.items?.length}
        </span>
      </a>
      <HeartDropdown wishlist={wishlist} />
    </div>
  );
}
